import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPasswordAPI } from "../../model/IndexModel";

const ResetPassword = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const uniqueToken = queryParams.get("uniqueToken");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

  useEffect(() => {
    const modalEl = new window.bootstrap.Modal(document.getElementById("resetPasswordModal"));
    modalEl.show();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setSuccess("");
      return;
    }

    if (!passwordRegex.test(newPassword)) {
      setError(
        "Password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character."
      );
      setSuccess("");
      return;
    }

    try {
      setLoading(true);
      const response = await resetPasswordAPI(token, newPassword);
      setLoading(false);

      if (response.error) {
        setError(response.error);
        setSuccess("");
      } else {
        setError("");
        setSuccess("Password has been reset successfully.");
        setTimeout(() => {
          navigate("/");
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      setLoading(false);
      setError("An error occurred while resetting the password.");
      setSuccess("");
    }
  };

  return (
    <div
      className="modal fade"
      id="resetPasswordModal"
      tabIndex="-1"
      aria-labelledby="resetPasswordModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="resetPasswordModalLabel">Reset Password</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <label>New Password *</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showNewPassword && newPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={loading}
                  style={{ paddingRight: "38px" }}
                />
                {newPassword && (
                  <span
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", background: "transparent", border: "none", color: "#aaa", display: "flex", alignItems: "center" }}
                  >
                    <i className={showNewPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                  </span>
                )}
              </div>
            </div>
            <div className="modal-body pt-0">
              <label>Confirm Password *</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showConfirmPassword && confirmPassword ? "text" : "password"}
                  className="form-control"
                  placeholder="Re-enter new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={loading}
                  style={{ paddingRight: "38px" }}
                />
                {confirmPassword && (
                  <span
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", background: "transparent", border: "none", color: "#aaa", display: "flex", alignItems: "center" }}
                  >
                    <i className={showConfirmPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                  </span>
                )}
              </div>
              {error && <p className="text-danger mt-2 text-center">{error}</p>}
              {success && <p className="text-success mt-2 text-center">{success}</p>}
            </div>
            <div className="modal-footer border-top-0 pt-1">
              <button
                type="submit"
                className="btn btn-primary d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#eb2a25",
                  borderColor: "#eb2a25",
                  minWidth: "120px",
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Resetting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
